import React, { useState } from "react";
import { Table } from "react-bootstrap";
import BasicPagination from "../../../../../Pagination/Pagination";
import EditDiner from "../EditDiner";
import ViewDiner from "../ViewDiner";
import AllSeatingUserModal from "./AllSeatingUserModal";

const WalkinSeatingPageComponent = (props) => {
  //state

  const [page, setPage] = useState(1);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const handleCloseView = () => setShowView(false);
  const [modalData, setModalData] = useState([]);
  const handleShowView = (user) => {
    setModalData(user);
    setShowView(true);
  };
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (user) => {
    setModalData(user);
    setShowEdit(true);
  };

  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  return (
    <>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
        <Table className="enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th style={{ width: "16.66%" }} className="f12-700">
                Restaurant
              </th>
              <th style={{ width: "16.66%" }} className="f12-700">
                Request type/no.
              </th>
              <th style={{ width: "16.66%" }} className="f12-700">
                Total PAX
              </th>
              <th style={{ width: "16.66%" }} className="f12-700">
                Status
              </th>
              <th style={{ width: "16.66%" }} className="f12-700">
                Date/Time
              </th>
              <th style={{ width: "16.66%" }} className="f12-700">
                Actions
              </th>
            </tr>
          </thead>
          {props &&
            props.diners &&
            props.diners
              .slice(start, end)
              .map((seating, index) => (
                <AllSeatingUserModal
                  seating={seating}
                  key={index}
                  handleShowView={(currentUserData) =>
                    handleShowView(currentUserData)
                  }
                  handleShowEdit={() => handleShowEdit(seating)}
                />
              ))}
        </Table>
      </div>
      {props.diners && props.diners.length !== 0 ? (
        <BasicPagination
          totalRecords={props.diners && props.diners.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <> </>
      )}

      <ViewDiner
        onClickCloseView={handleCloseView}
        onClickshowView={showView}
        onClickshowEdit={() => handleShowEdit(modalData)}
        userData={modalData}
      />
      {/* <EditDiner
        onClickCloseEdit={handleCloseEdit}
        onClickshowEdit={showEdit}
        userData={modalData}
      /> */}
    </>
  );
};

export default WalkinSeatingPageComponent;
